module.exports = __webpack_public_path__ + "img/Logo.f9eee83d.png";